export const featuredComics = [
  {
    id: 1,
    title: '重生之都市修仙',
    author: '金泰亨',
    category: '玄幻',
    rating: 9.6,
    chapters: 186,
    status: '连载中',
    updateTime: '3小时前',
    description: '一代仙尊渡劫失败，重生回到少年时代。这一世，他要弥补所有遗憾，踏上巅峰之路。前世的敌人，今生的羁绊，都市之中暗流涌动，修仙之路步步惊心。且看仙尊重生归来，如何以无敌之姿横扫八方，书写属于他的传奇篇章。',
    longDescription: '一代仙尊渡劫失败，重生回到少年时代。这一世，他要弥补所有遗憾，踏上巅峰之路。前世的敌人，今生的羁绊，都市之中暗流涌动，修仙之路步步惊心。且看仙尊重生归来，如何以无敌之姿横扫八方，书写属于他的传奇篇章。修炼千年，一朝归来的金泰亨，带着满级修为重走修行路。这一世，他不再有任何顾忌，所有曾经欺辱过他的人，都将付出代价。但在这条路上，他也遇到了前世未曾有过的温暖与羁绊...',
    chapters_list: Array.from({ length: 186 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话${i > 0 ? ' - ' + ['觉醒','初遇','危机','转机','决战'][i % 5] : ' - 序幕'}`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 1, username: '修仙小达人', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20cool%20expression%2C%20simple%20studio%20lighting%2C%20casual%20modern%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-01&orientation=squarish', rating: 5, content: '这部真的太爽了！男主重生的设定太带感，每一话都让人期待下一话！', date: '2026-07-07' },
      { id: 2, username: '夜雨声烦', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20elegant%2C%20simple%20studio%20lighting%2C%20natural%20makeup%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-02&orientation=squarish', rating: 5, content: '画风超级精美，战斗场面的分镜简直绝了，强烈推荐！', date: '2026-07-06' },
      { id: 3, username: '逍遥散人', avatar: 'https://readdy.ai/api/search-image?query=mature%20man%20portrait%20friendly%2C%20simple%20studio%20lighting%2C%20relaxed%20style%2C%20clean%20background&width=120&height=120&seq=comment-avatar-03&orientation=squarish', rating: 4, content: '剧情节奏把握得很好，不拖沓，每话都有看点。', date: '2026-07-05' },
    ],
    tags: ['重生', '修仙', '都市', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20young%20man%20with%20dark%20hair%20in%20modern%20city%20setting%2C%20mystical%20energy%20surrounding%20him%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20clean%20background%20with%20subtle%20gradient%2C%20digital%20art%20style%2C%20high%20quality%20manhwa%20cover%20art&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '婚途漫漫',
    author: '李智恩',
    category: '恋爱',
    rating: 9.4,
    chapters: 142,
    status: '连载中',
    updateTime: '6小时前',
    description: '契约婚姻开始的故事，两个陌生人如何在命运的捉弄下逐渐靠近彼此的心。冰冷的合同能否变成真挚的爱情？',
    longDescription: '契约婚姻开始的故事，两个陌生人如何在命运的捉弄下逐渐靠近彼此的心。冰冷的合同能否变成真挚的爱情？金融界冷面女王林夕，因家族利益被迫与商界新贵韩辰签订三年婚约。本以为只是各取所需，却在日复一日的相处中，发现彼此的真心。然而前女友的回归，商业对手的算计，让这段感情充满变数...',
    chapters_list: Array.from({ length: 142 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 4, username: '甜心小丸子', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20sweet%20smile%2C%20simple%20studio%20lighting%2C%20casual%20pink%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-04&orientation=squarish', rating: 5, content: '男女主的互动太甜了！每次看都姨母笑停不下来~', date: '2026-07-07' },
      { id: 5, username: '月光族', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20gentle%2C%20simple%20studio%20lighting%2C%20bookish%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-05&orientation=squarish', rating: 5, content: '画风细腻，服装设计也很考究，看得出作者很用心。', date: '2026-07-06' },
    ],
    tags: ['契约婚姻', '先婚后爱', '都市', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20art%2C%20elegant%20woman%20in%20white%20dress%20and%20handsome%20man%20in%20black%20suit%2C%20romantic%20atmosphere%2C%20soft%20pink%20and%20cream%20tones%2C%20cherry%20blossom%20petals%2C%20minimal%20background%2C%20high%20quality%20manhwa%20style&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '暗影猎手',
    author: '朴志训',
    category: '动作',
    rating: 9.7,
    chapters: 98,
    status: '连载中',
    updateTime: '1天前',
    description: '在这个被暗影笼罩的世界里，猎手们是唯一的光。少年觉醒猎手之力，踏上冒险之旅。暗影与光明，背叛与坚守。',
    longDescription: '在这个被暗影笼罩的世界里，猎手们是唯一的光。少年觉醒猎手之力，踏上冒险之旅。暗影与光明，背叛与坚守。平凡高中生李昊意外觉醒了猎手之力，被卷入一个隐藏在现实之下的暗影世界。这里充斥着来自异界的怪物，而猎手们是人类最后的防线。在一次次生死战斗中，李昊逐渐揭开自身血脉的秘密...',
    chapters_list: Array.from({ length: 98 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 25)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 6, username: '战斗天使', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20intense%2C%20simple%20studio%20lighting%2C%20sporty%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-06&orientation=squarish', rating: 5, content: '打斗场面燃炸了！每一场战斗的分镜都让人热血沸腾！', date: '2026-07-06' },
      { id: 7, username: '影之书', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20mysterious%2C%20simple%20studio%20lighting%2C%20dark%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-07&orientation=squarish', rating: 5, content: '世界观设定很完整，暗影体系的规则设计得很有意思。', date: '2026-07-05' },
    ],
    tags: ['战斗', '热血', '暗黑', '觉醒'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%2C%20warrior%20with%20sword%20in%20dark%20fantasy%20setting%2C%20glowing%20red%20eyes%2C%20dynamic%20pose%2C%20dark%20background%20with%20red%20energy%20effects%2C%20intense%20atmosphere%2C%20dramatic%20lighting%2C%20high%20quality%20digital%20illustration&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '危险的诱惑',
    author: '韩素希',
    category: '悬疑',
    rating: 9.5,
    chapters: 76,
    status: '连载中',
    updateTime: '2天前',
    description: '一场看似偶然的相遇，揭开层层谎言与阴谋。当真相浮出水面，谁才是真正的猎物？信任与猜疑的边界在哪里？',
    longDescription: '一场看似偶然的相遇，揭开层层谎言与阴谋。当真相浮出水面，谁才是真正的猎物？信任与猜疑的边界在哪里？女记者苏瑾为调查一起离奇失踪案，伪装身份接近嫌疑人沈明轩。然而在接触过程中，她发现自己正一步步陷入一个精心设计的陷阱。每一个线索都指向更深层的阴谋，每一个人都不像表面看起来那么简单...',
    chapters_list: Array.from({ length: 76 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 20)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 8, username: '推理控', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20intellectual%2C%20simple%20studio%20lighting%2C%20glasses%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-08&orientation=squarish', rating: 5, content: '剧情反转再反转，根本猜不到下一步会发生什么！', date: '2026-07-05' },
    ],
    tags: ['悬疑', '推理', '反转', '都市'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%2C%20mysterious%20woman%20with%20piercing%20gaze%20half%20face%20in%20shadow%2C%20dark%20moody%20atmosphere%2C%20deep%20purple%20and%20black%20tones%2C%20rainy%20night%20vibe%2C%20minimalist%20composition%2C%20high%20quality%20manhwa%20style&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '极限心跳',
    author: '郑宇盛',
    category: '恐怖',
    rating: 9.3,
    chapters: 64,
    status: '已完结',
    updateTime: '1周前',
    description: '十位参赛者，一座荒岛，一场残酷的生存游戏。每一次心跳都可能是最后一次。谁能活到最后？',
    longDescription: '十位参赛者，一座荒岛，一场残酷的生存游戏。每一次心跳都可能是最后一次。谁能活到最后？神秘组织邀请了十位来自不同领域的精英，参与一场名为"极限心跳"的生存挑战。然而比赛开始后，他们才发现这根本不是普通的游戏——每一个关卡都充满致命陷阱，而退出的代价是永远消失。恐惧在蔓延，信任在崩塌...',
    chapters_list: Array.from({ length: 64 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 9, username: '胆小鬼进化中', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20slightly%20scared%2C%20simple%20studio%20lighting%2C%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-09&orientation=squarish', rating: 5, content: '太刺激了！虽然有点吓人但完全停不下来，一口气看到最新！', date: '2026-07-04' },
    ],
    tags: ['生存游戏', '恐怖', '悬疑', '已完结'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20survival%20manhwa%20cover%2C%20group%20of%20people%20on%20dark%20island%2C%20ominous%20red%20moon%2C%20tense%20atmosphere%2C%20dark%20green%20and%20crimson%20tones%2C%20silhouettes%2C%20dramatic%20composition%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '办公室罗曼史',
    author: '赵美妍',
    category: '恋爱',
    rating: 9.2,
    chapters: 210,
    status: '连载中',
    updateTime: '5小时前',
    description: '冷静理智的女总监遇上热情似火的新人设计师，办公室里的心动故事悄然展开。职场与爱情的完美平衡。',
    longDescription: '冷静理智的女总监遇上热情似火的新人设计师，办公室里的心动故事悄然展开。职场与爱情的完美平衡。30岁的设计总监周雅琳，事业有成却感情空白，被公司上下称为"冰山女王"。直到新人设计师林宇入职，用他的热情和才华融化了这座冰山。但办公室恋情向来是职场大忌，他们该如何在事业与爱情之间做出选择？',
    chapters_list: Array.from({ length: 210 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 10, username: '职场小白', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20professional%2C%20simple%20studio%20lighting%2C%20office%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-10&orientation=squarish', rating: 4, content: '职场描写很真实，办公室恋情的微妙感刻画得特别好！', date: '2026-07-07' },
    ],
    tags: ['办公室', '姐弟恋', '职场', '甜宠'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20webtoon%20cover%2C%20stylish%20woman%20in%20business%20attire%20and%20young%20man%20in%20casual%20office%20wear%2C%20modern%20office%20background%2C%20warm%20sunset%20lighting%2C%20soft%20orange%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '异世界美食家',
    author: '金道贤',
    category: '奇幻',
    rating: 9.0,
    chapters: 155,
    status: '连载中',
    updateTime: '8小时前',
    description: '顶级厨师意外穿越到魔法世界，用现代厨艺征服异世界味蕾的奇妙冒险！美食与魔法的完美融合。',
    longDescription: '顶级厨师意外穿越到魔法世界，用现代厨艺征服异世界味蕾的奇妙冒险！美食与魔法的完美融合。米其林三星主厨韩哲，在一次厨房事故中意外穿越到了魔法与剑的异世界。在这里，他发现自己可以通过烹饪魔法食材来获得超能力。热腾腾的拉面能治愈伤口，精心烘焙的面包能增强魔力，而他最大的武器，就是那双能创造一切美味的双手！',
    chapters_list: Array.from({ length: 155 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 11, username: '吃货降临', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20cheerful%2C%20simple%20studio%20lighting%2C%20colorful%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-11&orientation=squarish', rating: 5, content: '深夜看这个简直是自虐！画的食物看起来太好吃了！', date: '2026-07-06' },
    ],
    tags: ['穿越', '美食', '魔法', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20cooking%20manhwa%20cover%2C%20chef%20in%20apron%20holding%20magical%20dish%2C%20fantasy%20kitchen%20with%20floating%20ingredients%2C%20warm%20golden%20glow%2C%20magical%20sparks%2C%20vibrant%20colors%2C%20clean%20composition%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '校园风云录',
    author: '崔敏浩',
    category: '校园',
    rating: 9.1,
    chapters: 230,
    status: '连载中',
    updateTime: '12小时前',
    description: '从被霸凌到成为校园传奇，他的逆袭之路充满了热血、友情和青春的味道。青春就该不留遗憾。',
    longDescription: '从被霸凌到成为校园传奇，他的逆袭之路充满了热血、友情和青春的味道。青春就该不留遗憾。高一新生崔志勋，性格懦弱，开学第一天就成为了校霸的欺凌对象。然而一次偶然的机会，他遇到了退役格斗冠军，开始学习格斗技巧。从一个任人欺负的弱者，到保护弱者的校园英雄，他的蜕变之旅就此展开...',
    chapters_list: Array.from({ length: 230 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 12, username: '热血高校生', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20energetic%2C%20simple%20studio%20lighting%2C%20school%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-12&orientation=squarish', rating: 5, content: '青春热血！每一话都让人想起自己的高中时代！', date: '2026-07-05' },
    ],
    tags: ['校园', '逆袭', '友情', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20confident%20student%20in%20school%20uniform%20with%20friends%20in%20background%2C%20bright%20sunny%20school%20campus%2C%20energetic%20vibe%2C%20blue%20sky%2C%20youthful%20atmosphere%2C%20clean%20modern%20style%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
  },
  {
    id: 9,
    title: '恶魔的契约',
    author: '宋允儿',
    category: '恋爱',
    rating: 9.5,
    chapters: 88,
    status: '连载中',
    updateTime: '2小时前',
    description: '为了拯救濒临破产的家族企业，她与神秘的财阀继承人签订了一份危险的契约。爱情与利益的博弈，谁先沦陷？',
    longDescription: '为了拯救濒临破产的家族企业，她与神秘的财阀继承人签订了一份危险的契约。爱情与利益的博弈，谁先沦陷？留学归来的艺术系才女申夏恩，面对家族企业的危机，被迫接受了一个神秘男人的帮助——韩氏集团的掌门人韩振宇。但这个帮助的背后，隐藏着一个她无法想象的秘密...',
    chapters_list: Array.from({ length: 88 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 22)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 13, username: '契约少女', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20elegant%2C%20simple%20studio%20lighting%2C%20chic%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-13&orientation=squarish', rating: 5, content: '霸道总裁爱上我的韩漫版！男主太帅了，女主也很独立。', date: '2026-07-07' },
    ],
    tags: ['契约', '财阀', '恋爱', '都市'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%2C%20glamorous%20woman%20in%20designer%20dress%20and%20charismatic%20man%20in%20luxury%20setting%2C%20golden%20hour%20lighting%2C%20champagne%20tones%2C%20sophisticated%20atmosphere%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
  },
  {
    id: 10,
    title: '血月传说',
    author: '姜东元',
    category: '动作',
    rating: 9.4,
    chapters: 120,
    status: '连载中',
    updateTime: '4小时前',
    description: '血月之夜，古老的封印破碎，沉睡千年的魔族重返人间。一群拥有特殊能力的战士，成为人类最后的希望。',
    longDescription: '血月之夜，古老的封印破碎，沉睡千年的魔族重返人间。一群拥有特殊能力的战士，成为人类最后的希望。古代猎魔人家族的后裔们，在现代都市中觉醒血脉之力。面对汹涌而来的魔族大军，他们必须集结起来，寻找失落的圣器，在血月再次降临之前，重新封印魔界之门...',
    chapters_list: Array.from({ length: 120 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 14, username: '猎魔人', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20serious%2C%20simple%20studio%20lighting%2C%20dark%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-14&orientation=squarish', rating: 5, content: '世界观宏大，战斗系统设计得非常有层次感！', date: '2026-07-07' },
    ],
    tags: ['猎魔', '战斗', '暗黑', '觉醒'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20warrior%20in%20black%20armor%20under%20blood%20red%20moon%2C%20ancient%20ruins%20background%2C%20dramatic%20crimson%20and%20black%20tones%2C%20epic%20atmosphere%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-10&orientation=portrait',
  },
  {
    id: 11,
    title: '搞笑一家人',
    author: '张英哲',
    category: '搞笑',
    rating: 9.0,
    chapters: 320,
    status: '连载中',
    updateTime: '1天前',
    description: '一个普通家庭里的爆笑日常。老爸的中年危机、老妈的网购成瘾、老姐的恋爱烦恼，还有那只会说话的猫！',
    longDescription: '一个普通家庭里的爆笑日常。老爸的中年危机、老妈的网购成瘾、老姐的恋爱烦恼，还有那只会说话的猫！张家四口加上一只神奇的猫，每天上演着啼笑皆非的生活闹剧。没有大道理，只有笑到肚子痛的日常。生活虽然平凡，但处处都是段子！',
    chapters_list: Array.from({ length: 320 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 45)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 15, username: '笑到岔气', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20laughing%2C%20simple%20studio%20lighting%2C%20bright%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-15&orientation=squarish', rating: 5, content: '每次看都笑到不行，那只猫简直是灵魂角色！', date: '2026-07-06' },
    ],
    tags: ['搞笑', '日常', '家庭', '轻松'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20family%20manhwa%20cover%2C%20funny%20family%20portrait%20with%20quirky%20expressions%2C%20bright%20warm%20colors%2C%20playful%20atmosphere%2C%20cartoon%20style%2C%20light%20background%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-11&orientation=portrait',
  },
  {
    id: 12,
    title: '九尾狐传',
    author: '尹智雅',
    category: '奇幻',
    rating: 9.6,
    chapters: 105,
    status: '连载中',
    updateTime: '9小时前',
    description: '千年九尾狐化身都市丽人，在现代社会寻找失落的内丹。妖与人、爱与恨，跨越千年的宿命轮回。',
    longDescription: '千年九尾狐化身都市丽人，在现代社会寻找失落的内丹。妖与人、爱与恨，跨越千年的宿命轮回。修行千年的九尾狐白璃，在渡天劫时失去内丹，被迫以人类形态在现代首尔生活。为了找回内丹，她开了一家占卜咖啡馆，却意外卷入了人类世界的纷争。更糟糕的是，她发现自己的内丹似乎与一个普通人类男子有关...',
    chapters_list: Array.from({ length: 105 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 26)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 16, username: '狐妖迷', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20mystical%2C%20simple%20studio%20lighting%2C%20elegant%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-16&orientation=squarish', rating: 5, content: '九尾狐的设定太美了！画风华丽，每一帧都可以当壁纸。', date: '2026-07-07' },
    ],
    tags: ['九尾狐', '奇幻', '都市', '爱情'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20nine-tailed%20fox%20spirit%20woman%20in%20modern%20city%2C%20mystical%20aura%2C%20ethereal%20white%20and%20silver%20tones%2C%20magical%20atmosphere%2C%20elegant%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-12&orientation=portrait',
  },
  {
    id: 13,
    title: '密室逃脱',
    author: '郑多彬',
    category: '悬疑',
    rating: 9.2,
    chapters: 45,
    status: '连载中',
    updateTime: '3天前',
    description: '六个陌生人在一间密闭房间中醒来，没有记忆，没有出口。他们必须解开连环谜题，在倒计时归零前逃出生天。',
    longDescription: '六个陌生人在一间密闭房间中醒来，没有记忆，没有出口。他们必须解开连环谜题，在倒计时归零前逃出生天。当六个互不相识的人在一间完全封闭的房间里苏醒，他们发现自己失去了所有记忆。房间里只有一张桌子、六把椅子、和一面硕大的倒计时屏幕。随着谜题一个个被解开，他们开始发现彼此之间存在着令人不安的联系...',
    chapters_list: Array.from({ length: 45 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 12)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 17, username: '密逃达人', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20clever%2C%20simple%20studio%20lighting%2C%20geeky%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-17&orientation=squarish', rating: 5, content: '每道谜题都很烧脑！代入感超强，感觉自己也在解谜。', date: '2026-07-04' },
    ],
    tags: ['密室', '解谜', '悬疑', '生存'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20six%20people%20in%20claustrophobic%20room%20with%20countdown%20clock%2C%20tense%20atmosphere%2C%20cold%20blue%20lighting%2C%20suspenseful%20composition%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-13&orientation=portrait',
  },
  {
    id: 14,
    title: '剑道至尊',
    author: '李成勋',
    category: '玄幻',
    rating: 9.5,
    chapters: 168,
    status: '连载中',
    updateTime: '7小时前',
    description: '剑道天才被奸人所害，重生回到十年前。这一世，他要守护所爱之人，以手中之剑，斩尽天下不平事！',
    longDescription: '剑道天才被奸人所害，重生回到十年前。这一世，他要守护所爱之人，以手中之剑，斩尽天下不平事！大陆第一剑尊叶无尘，在突破剑道至高境界时被至交好友背叛，含恨而终。重生回到少年时代的他，带着前世的记忆和剑道感悟，誓要改写命运，保护曾经失去的一切。一剑在手，天下我有！',
    chapters_list: Array.from({ length: 168 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 18, username: '剑道少年', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20determined%2C%20simple%20studio%20lighting%2C%20martial%20arts%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-18&orientation=squarish', rating: 5, content: '剑招描写太帅了！每一页都帅到炸裂！', date: '2026-07-06' },
    ],
    tags: ['剑道', '重生', '玄幻', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%2C%20sword%20master%20in%20traditional%20robe%20with%20glowing%20blade%2C%20mountain%20peak%20background%2C%20dramatic%20golden%20sunlight%2C%20epic%20atmosphere%2C%20high%20quality%20digital%20illustration&width=800&height=1067&seq=comic-cover-14&orientation=portrait',
  },
  {
    id: 15,
    title: '深夜怪谈社',
    author: '金世妍',
    category: '恐怖',
    rating: 9.1,
    chapters: 52,
    status: '连载中',
    updateTime: '2天前',
    description: '大学新生加入了一个神秘的社团——深夜怪谈社。每周期待的社团活动，却变成了一场场真实的恐怖经历。',
    longDescription: '大学新生加入了一个神秘的社团——深夜怪谈社。每周期待的社团活动，却变成了一场场真实的恐怖经历。大学新生李敏智被学姐拉入了"深夜怪谈社"，原本以为只是分享一些都市传说和鬼故事。然而当第一个故事讲完，社团成员开始陆续遭遇无法解释的灵异事件，他们才发现——有些故事，最好不要去讲...',
    chapters_list: Array.from({ length: 52 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 19, username: '不敢关灯', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20scared%2C%20simple%20studio%20lighting%2C%20casual%20dark%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-19&orientation=squarish', rating: 4, content: '大白天看都觉得后背发凉！恐怖氛围营造得太好了。', date: '2026-07-05' },
    ],
    tags: ['恐怖', '校园', '灵异', '怪谈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20campus%20manhwa%20cover%2C%20college%20students%20in%20dimly%20lit%20room%20telling%20ghost%20stories%2C%20eerie%20atmosphere%2C%20cold%20blue%20and%20gray%20tones%2C%20suspenseful%20composition%2C%20high%20quality%20dark%20illustration&width=800&height=1067&seq=comic-cover-15&orientation=portrait',
  },
  {
    id: 16,
    title: '篮球少年',
    author: '吴贤宇',
    category: '校园',
    rating: 9.3,
    chapters: 178,
    status: '连载中',
    updateTime: '10小时前',
    description: '身高仅170cm却怀揣篮球梦想的少年，凭借惊人的速度和精准的投篮，在高中篮球界掀起风暴！',
    longDescription: '身高仅170cm却怀揣篮球梦想的少年，凭借惊人的速度和精准的投篮，在高中篮球界掀起风暴！高中生朴泰俊虽然身高只有170cm，但拥有惊人的运动天赋。在无数次被嘲笑"矮子打什么篮球"之后，他遇见了改变他命运的教练。凭借超乎常人的速度和精准的三分球，他开始征服高中篮球联赛，向所有人证明——篮球，不只是高个子的运动！',
    chapters_list: Array.from({ length: 178 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 20, username: '灌篮高手', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20sporty%2C%20simple%20studio%20lighting%2C%20basketball%20jersey%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-20&orientation=squarish', rating: 5, content: '体育漫画的巅峰！比赛场面画得超有张力！', date: '2026-07-07' },
    ],
    tags: ['篮球', '校园', '热血', '逆袭'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20cover%2C%20basketball%20player%20in%20dynamic%20jump%20shot%20pose%2C%20stadium%20background%2C%20energetic%20orange%20and%20white%20tones%2C%20intense%20sports%20atmosphere%2C%20high%20quality%20illustration&width=800&height=1067&seq=comic-cover-16&orientation=portrait',
  },
  {
    id: 17,
    title: '搞笑网红养成记',
    author: '朴恩智',
    category: '搞笑',
    rating: 8.9,
    chapters: 95,
    status: '连载中',
    updateTime: '1天前',
    description: '普通上班族意外成为搞笑网红，从此生活天翻地覆。做内容、涨粉丝、接广告，笑料百出的网红人生！',
    longDescription: '普通上班族意外成为搞笑网红，从此生活天翻地覆。做内容、涨粉丝、接广告，笑料百出的网红人生！普普通通的上班族金美英，因为一段吃播翻车视频意外走红网络。从此她的人生被彻底改变——学剪辑、拍段子、接到第一个广告、被黑粉攻击、和同行撕扯...网红的世界，比她想象的精彩一百倍！',
    chapters_list: Array.from({ length: 95 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 24)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 21, username: '网红小达人', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20trendy%2C%20simple%20studio%20lighting%2C%20fashionable%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-21&orientation=squarish', rating: 5, content: '太真实了！做自媒体的酸甜苦辣全在里面了，又好笑又感动。', date: '2026-07-06' },
    ],
    tags: ['搞笑', '网红', '日常', '现代'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%2C%20quirky%20woman%20holding%20smartphone%20with%20ring%20light%2C%20social%20media%20theme%2C%20bright%20neon%20pink%20and%20yellow%20tones%2C%20fun%20atmosphere%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-17&orientation=portrait',
  },
  {
    id: 18,
    title: '武道宗师',
    author: '赵俊赫',
    category: '动作',
    rating: 9.6,
    chapters: 134,
    status: '连载中',
    updateTime: '6小时前',
    description: '退役特种兵成为高中体育老师，却在校园中发现了一个地下格斗场。为了保护学生，他重拾战斗本能。',
    longDescription: '退役特种兵成为高中体育老师，却在校园中发现了一个地下格斗场。为了保护学生，他重拾战斗本能。退役特种兵韩正宇本想在新学校过平静的教师生活，却意外发现了校园地下隐藏的非法格斗场。当他的学生被卷入其中，他不得不重新拿起武器，用自己的方式守护这片校园。曾经的战场英雄，如今是学生们的最后防线。',
    chapters_list: Array.from({ length: 134 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 30)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 22, username: '铁血汉子', avatar: 'https://readdy.ai/api/search-image?query=mature%20man%20portrait%20tough%2C%20simple%20studio%20lighting%2C%20military%20casual%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-22&orientation=squarish', rating: 5, content: '硬汉教师太帅了！格斗动作设计得很专业！', date: '2026-07-07' },
    ],
    tags: ['格斗', '校园', '热血', '保护'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20muscular%20martial%20arts%20fighter%20in%20teacher%20outfit%2C%20school%20corridor%20background%2C%20intense%20lighting%2C%20powerful%20stance%2C%20high%20quality%20dynamic%20illustration&width=800&height=1067&seq=comic-cover-18&orientation=portrait',
  },
  {
    id: 19,
    title: '末世重生',
    author: '都暻秀',
    category: '恐怖',
    rating: 9.4,
    chapters: 82,
    status: '连载中',
    updateTime: '4天前',
    description: '丧尸病毒爆发，世界陷入混乱。重生回到末日降临前一天的他，能否改变命运，拯救所爱之人？',
    longDescription: '丧尸病毒爆发，世界陷入混乱。重生回到末日降临前一天的他，能否改变命运，拯救所爱之人？在末日中挣扎求生三年的幸存者姜赫，死于一次物资搜寻行动。当他再次睁开眼睛，发现自己回到了末日爆发的前一天。这一次，他带着三年积累的生存经验和未来的记忆，誓死要保护家人和挚友，在灾难降临之前做好准备！',
    chapters_list: Array.from({ length: 82 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 21)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 23, username: '末日生存者', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20rugged%2C%20simple%20studio%20lighting%2C%20survival%20style%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-23&orientation=squarish', rating: 5, content: '末世重生题材中的佼佼者！紧张感拉满！', date: '2026-07-03' },
    ],
    tags: ['末世', '丧尸', '重生', '生存'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20apocalypse%20manhwa%20cover%2C%20survivor%20in%20destroyed%20city%20with%20zombies%20lurking%2C%20dark%20gray%20and%20crimson%20sky%2C%20intense%20survival%20atmosphere%2C%20dramatic%20composition%2C%20high%20quality%20digital%20art&width=800&height=1067&seq=comic-cover-19&orientation=portrait',
  },
  {
    id: 20,
    title: '魔法学院优等生',
    author: '安宰贤',
    category: '奇幻',
    rating: 9.2,
    chapters: 112,
    status: '连载中',
    updateTime: '11小时前',
    description: '出身平民的他，凭借惊人的魔法天赋考入顶级魔法学院。在这里，他将挑战贵族精英，改写魔法界的规则。',
    longDescription: '出身平民的他，凭借惊人的魔法天赋考入顶级魔法学院。在这里，他将挑战贵族精英，改写魔法界的规则。在魔法贵族垄断的魔法界，平民连学习魔法的资格都没有。但天才少年安秀浩以满分成绩考入了王国最顶尖的阿卡迪亚魔法学院，震惊了整个魔法界。在这里，他不仅要面对贵族学生的排挤，还要应对潜伏在学院中的黑暗势力...',
    chapters_list: Array.from({ length: 112 }, (_, i) => ({ num: i + 1, title: `第${i + 1}话`, date: `2026-${String(7 - Math.floor(i / 28)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}` })),
    comments: [
      { id: 24, username: '魔法学徒', avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20nerdy%2C%20simple%20studio%20lighting%2C%20wizard-like%20casual%2C%20clean%20minimal%20background&width=120&height=120&seq=comment-avatar-24&orientation=squarish', rating: 5, content: '魔法设定很有新意，学院生活描写也很丰富！', date: '2026-07-06' },
    ],
    tags: ['魔法', '学院', '逆袭', '奇幻'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20academy%20manhwa%20cover%2C%20young%20wizard%20student%20in%20magical%20school%20uniform%2C%20grand%20castle%20background%2C%20blue%20magical%20aura%2C%20enchanted%20atmosphere%2C%20high%20quality%20digital%20illustration&width=800&height=1067&seq=comic-cover-20&orientation=portrait',
  },
];

export const categories = [
  { id: 1, name: '恋爱', icon: 'ri-heart-line', count: 1280, slug: 'romance' },
  { id: 2, name: '玄幻', icon: 'ri-magic-line', count: 956, slug: 'fantasy' },
  { id: 3, name: '动作', icon: 'ri-sword-line', count: 843, slug: 'action' },
  { id: 4, name: '悬疑', icon: 'ri-search-eye-line', count: 621, slug: 'mystery' },
  { id: 5, name: '恐怖', icon: 'ri-ghost-line', count: 487, slug: 'horror' },
  { id: 6, name: '校园', icon: 'ri-building-line', count: 532, slug: 'school' },
  { id: 7, name: '奇幻', icon: 'ri-rocket-line', count: 764, slug: 'fantasy-adventure' },
  { id: 8, name: '搞笑', icon: 'ri-emotion-laugh-line', count: 391, slug: 'comedy' },
];

export const testimonials = [
  {
    id: 1,
    username: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20person%20portrait%2C%20simple%20studio%20lighting%2C%20casual%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot%20vibe&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '真的超级爱这个网站！韩漫的画风太精致了，每次更新第一时间就来追。下拉式阅读体验超棒，比翻页的方式舒服太多了。高清画质看着就是爽！',
    date: '2026-07-05',
  },
  {
    id: 2,
    username: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%2C%20simple%20studio%20lighting%2C%20modern%20casual%20look%2C%20clean%20minimal%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '终于找到一个更新快、画质好的韩漫网站了！收藏了很多喜欢的漫画，每天睡前都要刷两话。推荐给所有喜欢韩漫的朋友！',
    date: '2026-07-04',
  },
  {
    id: 3,
    username: '二次元研究员',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20glasses%2C%20simple%20studio%20lighting%2C%20smart%20casual%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '作为一个看了十年漫画的老粉，尾巴漫画的韩漫资源是真的全。分类清晰，找漫画特别方便。而且没有广告弹窗，体验一级棒！',
    date: '2026-07-03',
  },
  {
    id: 4,
    username: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20with%20long%20hair%2C%20simple%20studio%20lighting%2C%20elegant%20casual%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 4,
    comment: '恋爱类的韩漫真的太好看了！每次看到男女主互动的画面都心跳加速。希望可以增加更多完结作品的合集推荐。',
    date: '2026-07-02',
  },
  {
    id: 5,
    username: '热血少年郎',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20energetic%2C%20simple%20studio%20lighting%2C%20casual%20sporty%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-05&orientation=squarish',
    rating: 5,
    comment: '暗影猎手简直神作！画风炸裂，打斗场面超燃。尾巴漫画的阅读器做得很好，打斗场景的连贯性完美呈现。',
    date: '2026-07-01',
  },
  {
    id: 6,
    username: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=mature%20person%20portrait%2C%20simple%20studio%20lighting%2C%20relaxed%20casual%20style%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-06&orientation=squarish',
    rating: 5,
    comment: '从朋友推荐过来就停不下来了。网站加载速度很快，用手机看也特别流畅。收藏夹功能要是能分类就更好了！',
    date: '2026-06-30',
  },
];

export const stats = {
  totalComics: 8650,
  totalChapters: 528000,
  dailyVisitors: 320000,
  satisfaction: 98.5,
};

export const siteInfo = {
  name: '尾巴漫画网',
  description: '尾巴漫画网专注好看的韩国漫画，韩漫在线免费阅读体验流畅，高清无删减内容，下拉式设计让您沉浸其中。自2020年成立以来，我们致力于为广大韩漫爱好者提供最优质的在线阅读服务，汇聚海量优质韩漫资源，涵盖恋爱、玄幻、动作、悬疑、恐怖等多种类型，每日更新，永不掉队。',
  founded: '2020年',
  email: 'hello@sansevieria.cn',
  address: '在线服务平台',
};